var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.4401 8.145c-0.0117 1.1176 2.6104 2.9143 3.7537 2.5541-0.50322 0.41617-3.7945 1.9725-4.0824 1.7853-0.0494-0.0313-0.0776-0.11206-0.0951-0.26498-0.0853-0.76101 0.17942-3.5061 0.42377-4.0744zm4.4084-6.2037 3.8332 2.6177-3.8254 5.3068c-1.123 0.49988-4.0099-1.4833-3.8324-2.6179zm2.2109-1.8016 2.6094 1.7825c0.33847 0.22998 0.43246 0.66519 0.21229 0.97209l-0.63619 0.88185-3.8321-2.6177 0.63511-0.88172c0.22112-0.3061 0.67408-0.36772 1.0115-0.13695z",
    fill: "#006AF5",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0ef700dcfb047f92727a98b1b2e4604e.svg";
export { ForwardRef as ReactComponent };